
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import ExtractOptionInvolvementTile from './ExtractOptionInvolvementTile.vue'
import PriceDisplay from '@/domains/jobs/components/JobCreate/PriceDisplay.vue'


@Component({
  components: { ExtractOptionInvolvementTile, PriceDisplay }
})
export default class ExtractOption extends Vue {
  @Prop({ type: Number, default: 0 })
  selectedTemplateId!: number

  @Prop({ type: String, required: true })
  documentType!: string

  @Prop({ type: Object, default: () => ({}) })
  pricing!: any

  @Prop({ type: Array, default: () => [] })
  selectedFiles!: File[]

  @Prop({ type: Array, default: () => [] })
  providerTemplates!: any[]

  get requiredRule() {
    return (v: any) => !!v || 'Field is required'
  }

  get templates() {
    if (!this.providerTemplates) {
      return []
    }

    return this.providerTemplates.map(template =>
      ({ text: template.name, value: template.extractTemplateId })
    )
  }

  get templateId() {
    return this.selectedTemplateId
  }

  set templateId (id: number) {
    this.$emit('update:selectedTemplateId', id)
  }

  get price () {
    return this.providerTemplates.find(template => template.extractTemplateId === this.selectedTemplateId)?.providerTemplateFee || null
  }

  showFullTranslation() {
    this.$emit('makeFullTranslation')
  }

  removeFiles(file: File) {
    this.$emit('update:selectedFiles', this.selectedFiles.filter(selectedFile => selectedFile !== file))
  }
}
